import styled from "styled-components";

export const GalleryWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-gap: 3rem;
	align-items: center;
	justify-content: space-between;
	padding: 3rem 0;
`;
